module.exports = __webpack_public_path__ + "static/img/kpicon-eye-off.1801ae2e.svg";